import React from "react";
import {
  Container,
  Grid,
  Typography,
  Link,
  Box,
  IconButton,
} from "@mui/material";
import { Email as EmailIcon, Phone as PhoneIcon } from "@mui/icons-material";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import InstagramIcon from "@mui/icons-material/Instagram";
import TwitterIcon from "@mui/icons-material/Twitter";
import { Link as RouterLink } from "react-router-dom";
import SiteLogo from "../site-logo/SiteLogo";

const Footer = () => {
  return (
    <Box
      sx={{
        backgroundColor: "#0f0f0f",
        color: "white",
        borderTop: "1px solid #222",
        py: 6,
      }}
    >
      <Container>
        <Grid container spacing={4} sx={{ mb: 4 }}>
          {/* Left Section - Logo and Contact Info */}
          <Grid item size={{ xs: 12, md: 6 }}>
            <Box
              style={{
                marginBottom: 2,
              }}
            >
              <SiteLogo color={"#fff"} />
            </Box>
            <Typography variant="body1" sx={{ mb: 2 }}>
              POS by Truemenu
            </Typography>
            <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
              <EmailIcon sx={{ mr: 1 }} />
              <Link
                href="mailto:help.rista@dotpe.in"
                color="inherit"
                style={{
                  textDecoration: "none",
                }}
              >
                help@truemenu.in
              </Link>
            </Box>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <PhoneIcon sx={{ mr: 1 }} />
              <Link
                href="tel:+7066055251"
                color="inherit"
                style={{
                  textDecoration: "none",
                }}
              >
                7066055251
              </Link>
            </Box>
          </Grid>

          {/* Right Section - Products and Resources */}
          <Grid item size={{ xs: 12, md: 6 }}>
            <Grid container spacing={2}>
              <Grid item size={{ xs: 6, md: 6 }}>
                <Typography
                  variant="h6"
                  style={{
                    mb: 1,
                  }}
                >
                  Outlet Types
                </Typography>
                <Box
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "4px",
                  }}
                >
                  <Link
                    component={RouterLink}
                    to="/pos/food-court"
                    color="inherit"
                    display="block"
                    style={{
                      textDecoration: "none",
                    }}
                  >
                    Food court
                  </Link>
                  <Link
                    component={RouterLink}
                    to="/pos/cafe-shops"
                    color="inherit"
                    display="block"
                    style={{
                      textDecoration: "none",
                    }}
                  >
                    Cafe
                  </Link>
                  <Link
                    component={RouterLink}
                    to="/pos/cloud-kitchen"
                    color="inherit"
                    display="block"
                    style={{
                      textDecoration: "none",
                    }}
                  >
                    Cloud kitchen
                  </Link>
                  <Link
                    component={RouterLink}
                    to="/pos/ice-cream"
                    color="inherit"
                    display="block"
                    style={{
                      textDecoration: "none",
                    }}
                  >
                    Ice cream & desserts
                  </Link>
                  <Link
                    component={RouterLink} to="/pos/bakery"
                    color="inherit"
                    display="block"
                    style={{
                      textDecoration: "none",
                    }}
                  >
                    Bakery
                  </Link>
                  <Link
                    component={RouterLink}
                    to="/pos/fine-dine"
                    color="inherit"
                    display="block"
                    style={{
                      textDecoration: "none",
                    }}
                  >
                    Fine dine
                  </Link>
                  <Link
                    component={RouterLink}
                    to="/pos/qsr"
                    color="inherit"
                    display="block"
                    style={{
                      textDecoration: "none",
                    }}
                  >
                    QSR
                  </Link>
                  <Link
                    component={RouterLink}
                    to="/pos/pizzeria"
                    color="inherit"
                    display="block"
                    style={{
                      textDecoration: "none",
                    }}
                  >
                    Pizzeria
                  </Link>
                  <Link
                    component={RouterLink}
                    to="/pos/bar-brewery"
                    color="inherit"
                    display="block"
                    style={{
                      textDecoration: "none",
                    }}
                  >
                    Bar & Brewery
                  </Link>
                  <Link
                    component={RouterLink}
                    to="/pos/large-chain"
                    color="inherit"
                    display="block"
                    style={{
                      textDecoration: "none",
                    }}
                  >
                    Large chain
                  </Link>
                </Box>
              </Grid>
              <Grid item size={{ xs: 6, md: 6 }}>
                <Typography
                  variant="h6"
                  style={{
                    mb: 1,
                  }}
                >
                  Resources
                </Typography>
                <Box
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "4px",
                  }}
                >
                  <Link component={RouterLink} to="/pos/faqs" color="inherit" display="block" style={{ textDecoration: "none" }}>FAQs</Link>
                  <Link component={RouterLink} to="/pos/about-us" color="inherit" display="block" style={{ textDecoration: "none" }}>About Us</Link>
                  <Link component={RouterLink} to="/pos/contact-us" color="inherit" display="block" style={{ textDecoration: "none" }}>Contact Us</Link>
                  <Link component={RouterLink} to="/pos/terms-and-conditions" color="inherit" display="block" style={{ textDecoration: "none" }}>Terms of Service</Link>
                  <Link component={RouterLink} to="/pos/privacy-policy" color="inherit" display="block" style={{ textDecoration: "none" }}>Privacy Policy</Link>
                  <Link component={RouterLink} to="/pos/cancellation-refund-policy" color="inherit" display="block" style={{ textDecoration: "none" }}>Refund Policy</Link>
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        {/* Bottom Section - Copyright and Social Media Icons */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="body2">
            © {new Date().getFullYear()} TrueMenu — All rights reserved by
            ABNScripts Pvt. Ltd.
          </Typography>
          <Box>
            <IconButton href="#" color="inherit">
              <TwitterIcon />
            </IconButton>
            <IconButton href="#" color="inherit">
              <LinkedInIcon />
            </IconButton>
            <IconButton href="#" color="inherit">
              <InstagramIcon />
            </IconButton>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
